<template>
  <ion-page>
    <ion-header>
      <ion-toolbar>
        <ion-buttons slot="start">
          <ion-back-button default-href="/"></ion-back-button>
        </ion-buttons>
        <ion-title>COVID-19</ion-title>
      </ion-toolbar>
    </ion-header>
    <ion-content padding>
      <div style="height: 400px; width: 100%">
          <l-map ref="mymap" style="height: 400px;" :zoom="zoom" :center="center">
              <l-tile-layer :url="url" :attribution="attribution"></l-tile-layer>
              <l-geo-json :geojson="provinces" :options-style="style" :options="geo_options"></l-geo-json>
          </l-map>
      </div>
      <div>
        <ion-grid>
          <ion-row>
            <ion-col>
              <ion-item>
                <ion-label>Location</ion-label>
                <ion-select value="KwaZulu-Natal" placeholder="Select One">
                    <ion-select-option>KwaZulu-Natal</ion-select-option>
                </ion-select>
            </ion-item>
            </ion-col>
          </ion-row>
          <ion-row padding>
            <ion-col class="ion-text-center">
              <h5>Confirmed</h5>
              <h3>{{latest_stats.confirmed}}</h3>
            </ion-col>
            <ion-col class="ion-text-center">
              <h5>Recovered</h5>
              <h3>{{latest_stats.recovered}}</h3>
            </ion-col>
            <ion-col class="ion-text-center">
              <h5>Deaths</h5>
              <h3>{{latest_stats.deaths}}</h3>
            </ion-col>
          </ion-row>
          <ion-row>
            <ion-col>
              <ion-button expand="full">Refresh</ion-button>
            </ion-col>
          </ion-row>
        </ion-grid>
      </div>
    </ion-content>
  </ion-page>
</template>

<script>
import {LMap,LTileLayer,LGeoJson} from 'vue2-leaflet';
import provinces_south from '../assets/kzn.json';
import L from 'leaflet';
export default {
    name:'stats',
    components:{
        LMap,
        LTileLayer,
        LGeoJson
    },
    data(){
        return {
            latest_stats:{
              deaths:0,
              recovered:0,
              confirmed:0
            },
            all_stats:[],
            provinces:provinces_south,
            geo_options:{
              onEachFeature: function (feature, layer) {
                  layer.bindPopup(''+feature.properties.MAP_TITLE+'<br>Confirmed Cases: '+feature.properties.confirmed);
              }
            },
            zoom:6.5,
            center: L.latLng(-28.695142, 31.197613),
            url:'http://{s}.tile.osm.org/{z}/{x}/{y}.png',
            attribution:'&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors',
        }
    },
    methods:{
        loadMap(){
            setTimeout(() => {
                this.$refs.mymap.mapObject.invalidateSize(); 
            }, 100);
        },
        getColor(d) {
            return d > 1000 ? '#800026' :
                  d > 500  ? '#BD0026' :
                  d > 200  ? '#E31A1C' :
                  d > 100  ? '#FC4E2A' :
                  d > 50   ? '#FD8D3C' :
                  d > 20   ? '#FEB24C' :
                  d > 10   ? '#FED976' :
                              '#FFEDA0';
        },
        style(feature) {
            return {
                fillColor: this.getColor(feature.properties.confirmed),
                weight: 2,
                opacity: 1,
                color: 'white',
                dashArray: '3',
                fillOpacity: 0.7
            };
        },
        loadStats(){
          const api="https://api.covid19api.com/total/country/south-africa";
          this.$http.get(api)
          .then((res)=>this.processData(res.data))
          .catch((err)=>console.log(err));
        },
        fetchStats(){
            const base_url=this.$store.get('base_url');
            this.$http.get(base_url+'/api/statistics/12')
            .then((res)=>this.latest_stats=res.data)
            .catch((err)=>{console.log(err)});
        },
        fetchAllStats(){
            const base_url=this.$store.get('base_url');
            this.$http.get(base_url+'/api/statistics')
            .then((res)=>this.all_stats=res.data)
            .then(()=>this.processStats())
            .catch((err)=>{console.log(err)});
        },
        processStats(){
          for(var i=0;i<this.provinces.features.length;i++){
            var stat=this.all_stats.find(st=>{
              return st.id===this.provinces.features[i].properties.id;
            });
            this.provinces.features[i].properties.confirmed=stat.confirmed;
            this.provinces.features[i].properties.recovered=stat.recovered;
            this.provinces.features[i].properties.deaths=stat.deaths;
          }
        },
        processData(data){
          let latest=data[data.length-1];
          this.latest_stats.deaths=latest.Deaths;
          this.latest_stats.recovered=latest.Recovered;
          this.latest_stats.confirmed=latest.Confirmed;
        }
    },
    mounted(){
        this.loadMap();
    },
    created(){
      this.fetchAllStats();
      this.fetchStats();
    }
}
</script>

<style scoped>
ion-toolbar {
  --ion-toolbar-background:#fbc414;
  --ion-text-color:white;
}
ion-back-button{
    --color:white;
}
ion-button{
    --background:#1b9346;
}
#rounded{
    --border-color: #d2d2d2;
  --border-radius: 10px;
  --border-width: 1px;
  --box-shadow: 2px gray;
  --highlight-height: 0;
  --background: #f8f9fa;
  margin: 10px;
}
</style>